export default __webpack_public_path__ + "static/media/home_think_outside_box.87d54b5c.mp3";